module.exports = __webpack_public_path__ + "static/pwp-og-image-b0ded33c459aa9c60862829d1a213a1e.png";